<template>
    <div>
        <div v-if="!isSent" @click="openModal" class="btn btn-sm cursor-pointer bg-pink-400 text-white">
            💝 Отправить Валентинку
        </div>
        <div v-if="isSent" class="btn btn-sm btn-default">
            💝 Валентинка отправлена
        </div>
    </div>

    <popup-modal ref="popup">
        <h2 class="font-bold mb-4 text-xl text-pink-600">
            Анонимная Валентинка
        </h2>
        <div class="text-sm mb-4">
            Вы можете отправить <strong>только одну Валентинку каждому пользователю</strong>.
            Получатель не увидит отправителя.
        </div>
        <div class="alert alert-danger my-2 text-xs space-y-2 p-2">
            <div class="text-red-600 cursor-pointer" @click="warningOpened = !warningOpened">
                ‼️️ Важные правила
            </div>
            <div v-if="warningOpened">
                <strong>Good vibes only!</strong>
                В случае получения жалобы на вашу Валентинку ее проверит модератор.
                В случае обнаружения оскорблений и других нарушений правил вы будете забанены.
                Администраторы видят отправителей.
            </div>
        </div>
        <div class="mb-4 space-y-4">
            <formcontrol class="mb-4"
                         maxlength="64"
                         :autofocus="1"
                         placeholder="Заголовок"
                         :required="1"
                         v-model="form.subject"></formcontrol>

            <textarea ref="reason"
                      :required="1"
                      maxlength="500"
                      v-model="form.body"
                      placeholder="Признайтесь в любви, напишите добрые слова"
                      class="w-full h-40 input mb-4 focus:outline-none bg-white/10"
            ></textarea>
        </div>
        <div class="flex items-center justify-between">
            <button class="btn btn-md" @click="cancel">
                Отмена
            </button>
            <span class="btn btn-md bg-pink-500 text-white" @click="send">
                Отправить
            </span>
        </div>
    </popup-modal>
</template>
<script>
import PopupModal from "../partials/PopupModal.vue";
import Formcontrol from "../form/formcontrol.vue";
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";

export default {
    components: {Formcontrol, PopupModal},
    props: ['userid', 'sent'],
    data() {
        return {
            loading: false,
            isSent: this.sent,
            warningOpened: false,
            form: {
                subject: '',
                body: '',
            }
        };
    },
    methods: {
        openModal() {
            this.$refs.popup.open();
        },
        send() {
            if (this.loading) {
                return;
            }

            if (!this.form.subject.length || !this.form.body.length) {
                notify({
                    type: 'error',
                    text: 'Заполните все поля',
                });
                return;
            }

            this.loading = true;
            Client.post('/api/v1.1/user/' + this.userid + '/valentine', this.form)
                .then(() => {
                    notify({text: 'Валентинка отправлена!', type: 'success'});
                    this.form = {
                        subject: '',
                        body: '',
                    };
                    this.isSent = true;
                })
                .catch(error => {
                    notify({text: 'Не удалось отправить', type: 'error'});
                })
                .finally(() => {
                    this.$refs.popup.close();
                    this.loading = false;
                });
        },
        cancel() {
            this.$refs.popup.close();
        },
    }
}
</script>